import {TolgeeProvider} from "@tolgee/react";
import {ReactNode} from "react";
import tolgee from ".";

const I18nProvider = ({children}: {children: ReactNode}) => (
  <TolgeeProvider tolgee={tolgee} fallback="Loading...">
    {children}
  </TolgeeProvider>
);

export default I18nProvider;
